const PMServiceVisitTimesRed = [
  [-6.0, 1],
  [-23.0, 1],
  [-2.0, 1],
  [-4.0, 1],
  [-2.0, 3],
  [-17.0, 3],
  [-2.0, 3],
  [-2.0, 4],
  [-5.0, 4],
  [-14.0, 4],
  [-9.0, 5],
  [-27.0, 5],
  [-11.0, 6],
  [-5.0, 6],
  [-5.0, 7],
  [-7.0, 7],
  [-23.0, 7],
  [-15.0, 8],
  [-15.0, 8],
  [-31.0, 9],
  [-9.0, 9],
  [-6.0, 10],
  [-18.0, 10],
  [-3.0, 10],
  [-2.0, 11],
  [-23.0, 12],
  [-12.0, 12],
  [-9.0, 12],
  [-21.0, 12],
  [-7.0, 13],
  [-4.0, 13],
  [-11.0, 14],
  [-23.0, 15],
  [-20.0, 17],
  [-8.0, 18],
  [-12.0, 20],
  [-4.0, 20],
  [-10.0, 20],
  [-2.0, 20],
  [-12.0, 21],
  [-3.0, 21],
  [-2.0, 21],
  [-38.0, 22],
  [-2.0, 23],
  [-11.0, 23],
  [-6.0, 25],
  [-4.0, 25],
  [-8.0, 26],
  [-33.0, 27],
  [-2.0, 27],
  [-17.0, 27],
  [-25.0, 27],
  [-9.0, 28],
  [-18.0, 28],
  [-38.0, 29],
  [-20.0, 30],
  [-8.0, 30],
  [-17.0, 30],
  [-6.0, 32],
  [-5.0, 35],
  [-4.0, 36],
  [-2.0, 36],
  [-6.0, 37],
  [-9.0, 38],
  [-4.0, 38],
  [-15.0, 40],
  [-15.0, 40],
  [-18.0, 40],
  [-8.0, 40],
  [-2.0, 40],
  [-21.0, 41],
  [-13.0, 41],
  [-19.0, 41],
  [-12.0, 43],
  [-22.0, 43],
  [-8.0, 44],
  [-38.0, 45],
  [-19.0, 47],
  [-14.0, 47],
  [-8.0, 48],
  [-14.0, 48],
  [-11.0, 48],
  [-32.0, 49],
  [-12.0, 50],
  [-14.0, 53],
  [-7.0, 54],
  [-21.0, 55],
  [-3.0, 55],
  [-3.0, 55],
  [-26.0, 57],
  [-5.0, 58],
  [-15.0, 58],
  [-12.0, 58],
  [-5.0, 59],
  [-22.0, 61],
  [-2.0, 62],
  [-2.0, 62],
  [-6.0, 62],
  [-11.0, 63],
  [-13.0, 64],
  [-21.0, 65],
  [-33.0, 66],
  [-2.0, 66],
  [-45.0, 67],
  [-39.0, 70],
  [-22.0, 71],
  [-6.0, 75],
  [-11.0, 75],
  [-7.0, 82],
  [-78.0, 84],
  [-4.0, 86],
  [-6.0, 86],
  [-79.0, 88],
  [-45.0, 91],
  [-27.0, 92],
  [-18.0, 94],
  [-34.0, 95],
  [-6.0, 100],
  [-2.0, 103],
  [-17.0, 103],
  [-10.0, 105],
];

export default PMServiceVisitTimesRed;
